import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { Grid } from '@material-ui/core';
import { ControlledCheckboxGroup, ControlledInput, GridFormElement } from '../form-controls';
import { CreateUserDetails } from '../../api/studykit';
import { FormFooter } from '../styled/form-footer';
import {
  AsyncSubmitHandler,
  useFormWithServerErrorHandling,
} from '../../helpers/form-error-handling';
import { groupToRole } from '../dialogs/edit-user-roles-dialog';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

interface CreateUserFormProps {
  onSubmit: AsyncSubmitHandler<CreateUserDetails>;
  onCancel: () => void;
  user?: CreateUserDetails;
}

export const CreateUserForm: React.FC<CreateUserFormProps> = ({ onSubmit, onCancel, user }) => {
  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useFormWithServerErrorHandling<CreateUserDetails>({
    defaultValues: { ...user, roles: [] },
  });

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <GridFormElement label={'Email Address'} md={12}>
            <ControlledInput
              control={control}
              name={'email'}
              inputProps={{ fullWidth: true }}
              rules={{
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address',
                },
              }}
            />
          </GridFormElement>
          <GridFormElement label={'Roles'} md={12}>
            <Grid container spacing={1}>
              <ControlledCheckboxGroup
                name={'roles'}
                control={control}
                options={groupToRole}
                rules={{
                  required: 'At least one role has to be selected',
                }}
              />
            </Grid>
          </GridFormElement>
        </Grid>
        <FormFooter isSubmitting={isSubmitting} onCancel={onCancel} />
      </form>
    </MuiPickersUtilsProvider>
  );
};
